import React from 'react';
import { useMessage } from '../messages/useMessage';
import { useUserService } from '../services/user-service';

export const useUserController = () => {
  const {
    getSebrae,
    getCheck,
    putGrantAccess,
    postResendEmailValidateUser,
    postSendEmailValidateUser,
  } = useUserService();

  const [loading, setLoading] = React.useState(false);
  const { handleError, handleSuccess, handleAttention } = useMessage();

  const findSebrae = React.useCallback(() => {
    setLoading(true);
    return getSebrae()
      .then((data) => data)
      .catch(() => {
        return undefined;
      })
      .finally(() => setLoading(false));
  }, [getSebrae]);

  const checkUser = React.useCallback(() => {
    setLoading(true);
    return getCheck()
      .then((data) => data)
      .catch((error) => {
        handleError(error?.message);
        throw error;
      })
      .finally(() => setLoading(false));
  }, [getCheck, handleError]);

  const grantAccess = React.useCallback(
    (cpf) => {
      setLoading(true);
      return putGrantAccess(cpf)
        .then((data) => data)
        .catch((error) => {
          handleError(error?.message);
          throw error;
        })
        .finally(() => setLoading(false));
    },
    [handleError, putGrantAccess],
  );

  const resendEmailValidateUser = React.useCallback(() => {
    setLoading(true);
    return postResendEmailValidateUser()
      .then((data) => {
        handleSuccess('E-mail enviado com sucesso!');
      })
      .catch((error) => {
        handleError(error?.message);
        throw error;
      })
      .finally(() => setLoading(false));
  }, [handleError, handleSuccess, postResendEmailValidateUser]);

  const sendEmailValidateUser = React.useCallback(
    (email) => {
      setLoading(true);
      return postSendEmailValidateUser(email)
        .then((data) => {
          handleSuccess('E-mail enviado com sucesso!');
        })
        .catch((error) => {
          handleAttention(error?.message);
          throw error;
        })
        .finally(() => setLoading(false));
    },
    [handleAttention, handleSuccess, postSendEmailValidateUser],
  );

  return {
    findSebrae,
    checkUser,
    grantAccess,
    resendEmailValidateUser,
    sendEmailValidateUser,
    loading,
  };
};
